import { Theme, createStyles, WithStyles, AppBar, Button } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import React from "react";
import { AuthContext } from "../authentication/AuthContext";
import { ExitToApp } from '@material-ui/icons';
import { DeltaXMLColors } from "./styling/DeltaColors";

const styles = (theme: Theme) =>
  createStyles({
    toolbar: {
      backgroundColor: DeltaXMLColors.DARK_BACKGROUND,
      flexDirection: 'row',
      padding: '6px 17px 15px 3px',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      height: '65px'
    }
  });

interface HeaderProps extends WithStyles<typeof styles> {

}

function Header(props: HeaderProps) {
  const { classes } = props;
  const auth = React.useContext(AuthContext);
  const [authButton, setAuthButton] = React.useState(<></>);
  let timer = 50;
  const authenticationTimer = (count: number) => {
    setTimeout(() => {
      if (auth.isAuthenticated()) {
        setAuthButton(<Button variant="contained" endIcon={<ExitToApp />} color="secondary" onClick={() => auth.logout()} id="SignOutButton">Sign Out</Button>);
      } else if (count > 0) {
        timer = timer * 2;
        authenticationTimer(count -1);
      } else {
        auth.login();
      }
    }, timer);
  }

  React.useEffect(() => {
    authenticationTimer(4);
    timer = 50;
  },[]);

  return (
    <AppBar className={classes.toolbar} position="static" elevation={0}>
      {/* No text in the header bar for the moment */}
      {authButton}
    </AppBar>
  );
}

export default withStyles(styles)(Header);
